import { DisplayBehavior, ToolTipType, ToolTipWrapper } from "app/core/components/hints"
import { FC } from "react"
import { FiAlertTriangle } from "@superwall/icons/fi/FiAlertTriangle"

export const DropdownError: FC<{ normalizedError: string; hasLabel: boolean }> = ({
  normalizedError,
  hasLabel,
}) => {
  return (
    <ToolTipWrapper
      role="alert"
      displayBehavior={DisplayBehavior.Hover}
      className="
        appearance-none
        cursor-pointer
        absolute
        mr-3"
      toolTip={{ state: ToolTipType.Alert, value: normalizedError }}
      style={{ bottom: "12px", right: "25px" }}
    >
      <FiAlertTriangle className="text-alert-primary" />
    </ToolTipWrapper>
  )
}

export default DropdownError
